import { BrowserRouter } from 'react-router-dom';
import { QueryProvider } from './providers/QueryProvider.js';
import { ToastProvider } from '@shared/ui/Toast/Toast.js';
import { AuthProvider } from './providers/AuthProvider.js';
import { ThemeManager } from './theme/ThemeManager.js';
import { AppRoutes } from './router/routes.js';

export function App() {
  return (
    <BrowserRouter>
      <QueryProvider>
        <ToastProvider>
          <AuthProvider>
            <ThemeManager />
            <AppRoutes />
          </AuthProvider>
        </ToastProvider>
      </QueryProvider>
    </BrowserRouter>
  );
}
